<template>
  <div class="volumechooser">
    <div class="volumechooser-background" v-if="cover" :style="{backgroundImage: `url('${cover}')`}"/>
    <div class="volumechooser-blur"/>
    <div class="volumechooser-inner">
      <a class="volumechooser-book" v-for="b in books" :key="`vc-${b.Id}`" @click="select(b)">
        <div class="volumechooser-book-language" v-html="b.Options.Language === 'german' ? 'DE' : b.Options.Language.substr(0,2)"/>
        <div class="volumechooser-book-left" v-html="b.Options.Author"/>
        <div class="volumechooser-book-right">
          <p v-html="b.Name"/>
          <p v-html="b.Options.Subtitle"/>
        </div>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'VolumeChooser',
  computed: {
    books () {
      return this.$root.volumeChoice || []
    },
    // the volumes offered here share a running number, so any of their covers
    // works as a backdrop: take the first one that actually has an asset
    cover () {
      const _book = this.books.find(b => b.Options && b.Options.CoverAsset && b.Options.CoverAsset.Files && b.Options.CoverAsset.Files.Resized)
      if (!_book) return false
      const _resized = _book.Options.CoverAsset.Files.Resized
      return _resized[2] || _resized[_resized.length - 1] || false
    }
  },
  methods: {
    select (book) {
      this.$root.selectVolume(book)
    }
  }
}
</script>

<style lang="scss">

@import '../main';

.volumechooser {
  z-index: 5000;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  @include flex-vertical-center;
  &-background,
  &-blur {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  &-background {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  &-blur {
    backdrop-filter: blur(var(--padding-05));
  }
  &-inner {
    position: relative;
    width: 40vw;
    min-width: 600px;
    @include sm() {
      width: 80vw;
      min-width: auto;
    }
    box-sizing: border-box;
    background: var(--paper-color);
    color: var(--context-tray-font-color);
    @include tocfont();
    text-transform: uppercase;
    border: 1px solid var(--context-tray-font-color);
  }
  &-book {
    display: flex;
    position: relative;
    cursor: pointer;
    border-top: 1px solid var(--context-tray-font-color);
    padding: var(--padding);
    padding-top: var(--padding);
    padding-right: var(--padding-20);
    overflow: hidden;
    &:first-child {
      border-top: none;
      margin-top: 0;
    }
    &:active,
    &:focus,
    &:hover {
      color: inherit !important;
      transition: all 0.25s;
    }
    // marker sits in the gutter so hovering does not shift the entry
    &:hover {
      background: white;
      &:before {
        transform: translateX(0%);
      }
      .volumechooser-book-language {
        transform: rotate(90deg);
      }
    }
    p {
      margin: 0;
      padding: 0;
      &:last-child {
        font-style: italic;
      }
    }
    &-left {
      flex-basis: 45%;
    }
    &-right {
      flex-basis: 55%;
    }
    &-language {
      position: absolute;
      right: 3px;
      top: calc(var(--padding) + 6px);
      @include smallfont_grotesk();
      transform: rotate(90deg) translateY(-120%);
      transition: all 0.25s;
    }
    @include sm() {
      display: block;
      &-left,
      &-right {
        display: block;
        width: 100%;
      }
      &-right {
        margin-top: var(--padding-05);
      }
    }
    &:before {
      content: "";
      width: var(--padding-15);
      right: 0px;
      top: 0px;
      height: 100%;
      position: absolute;
      background: var(--paper-color);
      transform: translateX(100%);
      transition: all 0.25s;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VolumeChooser.vue